<div [ngStyle]="appliedStyle">
	<div class="table-scroll-wrapper" id="table-scroll-wrapper">
		<div class="table-responsive" id="table-responsive">
			<table class="data-table__table input-tax" [ngClass]="{'bt':isMobileView}">

				<thead>
					<tr>
						<th class="th-txt-use" scope="col" i18n="@@expenses.tax_used_for">Tax used for</th>
						<th class="th-tax-num" scope="col" i18n="@@expenses.receipt_invoice_no">Receipt/Invoice no</th>
						<th class="th-date" scope="col" i18n="@@expenses.date">Date</th>
						<th class="th-client" scope="col" i18n="@@expenses.vendor">Vendor</th>
						<th class="th-vat-reg" scope="col" i18n="@@expenses.vat_reg_no">VAT Reg.No.</th>
						<th class="th-project" scope="col" i18n="@@expenses.description">Description</th>
						<th class="th-amount" scope="col" i18n="@@expenses.taxable_invoice">Taxable invoice</th>
						<th class="th-vat-rat" scope="col">
							<ng-container i18n="@@expenses.vat_rate">VAT Rate</ng-container>
						</th>
						<th class="th-amount" scope="col" i18n="@@expenses.net_vat_amount">Net VAT amount</th>
						<th class="th-edit-icon"></th>
					</tr>
				</thead>

				<tbody>
					<ng-container *ngIf="inputTaxes && inputTaxes.length > 0; else noRecord">
						<ng-container *ngFor="let row of inputTaxes?.controls | paginate: paginator; index as i">
							<!-- Start This <tr> is used for edit the record -->
							<tr *ngIf="row.get('edit')?.value; else expenseReadOnly" class="pe-fieldset expenses-form"
								[formGroup]="row">

								<td class="td-txt-use" scope="row" i18n-data-th="@@expenses.tax_used_for"
									data-th="Tax used for">
									<span class="bt-content">
										{{ row.get('expense_type').value == 'handling_fees' ? 'COGS' : 'G&A' }}
									</span>
								</td>

								<td class="td-tax-num" i18n-data-th="@@expenses.receipt_invoice_no"
									data-th="Receipt/Invoice no">
									<span class="bt-content">
										<fieldset
											[ngClass]="{'has-error': isSubmitted(row) && row.get('receipt_number').errors?.required }">
											<input type="number" name="input_tax_receipt_number"
												formControlName="receipt_number" min="0" id="input_tax_receipt_number"
												class="amount-input" placeholder="0">
											<span class="field-error"
												*ngIf="isSubmitted(row) && row.get('receipt_number').errors?.required">Required</span>
										</fieldset>
									</span>
								</td>

								<td class="td-date" i18n-data-th="@@expenses.date" data-th="Date">
									<span class="bt-content">
										<div class="date">
											<span class="day">{{ row.get('expense_date').value | date:'dd' }}</span>
											<span class="month">{{ row.get('expense_date').value | date:'MMM' }}</span>
										</div>
									</span>
								</td>

								<td class="td-client-name" i18n-data-th="@@expenses.vendor" data-th="Vendor">
									<span class="bt-content">
										<fieldset
											[ngClass]="{'has-error': isSubmitted(row) && row.get('vendor_name').errors?.required}">
											<input type="text" name="vendor_name" formControlName="vendor_name"
												id="vendor_name" class="amount-input" placeholder="Vendor Name">
											<span class="field-error"
												*ngIf=" isSubmitted(row) && row.get('vendor_name').errors?.required">Required</span>
										</fieldset>
									</span>
								</td>

								<td class="td-vat-reg" i18n-data-th="@@expenses.vat_reg_no" data-th="VAT Reg.No.">
									<span class="bt-content">
										<fieldset
											[ngClass]="{'has-error': isSubmitted(row) && row.get('vat_number').errors?.required}">
											<input type="text" name="input_tax_vat_number" formControlName="vat_number"
												id="input_tax_vat_number" class="amount-input" placeholder="0">
											<span class="field-error"
												*ngIf="isSubmitted(row) && row.get('vat_number').errors?.required">Required</span>
										</fieldset>
									</span>
								</td>

								<td class="td-project-name" i18n-data-th="@@expenses.description" data-th="Description">
									<span class="bt-content">
										{{ row.get('description').value }}
									</span>
								</td>

								<td class="td-taxable-inv" i18n-data-th="@@expenses.taxable_invoice"
									data-th="Taxable invoice">
									<input type="hidden" name="taxable_amount" formControlName="taxable_amount"
										value="{{ row.get('cost').value }}" />
									<span class="bt-content">
										<span class="sar" [innerHtml]="userInfo?.currency_symbol"></span>
										{{ row.get('cost').value }}
									</span>
								</td>

								<td class="td-net-vat" i18n-data-th="@@expenses.vat_rate" data-th="VAT Rate">
									<span class="bt-content">
										<fieldset
											[ngClass]="{'has-error': isSubmitted(row) && row.get('vat_percentage').errors}">
											<input type="number" min="0" max="100"
												[innerHtml]="userInfo?.currency_symbol" name="vat_percentage"
												formControlName="vat_percentage" (input)="onVatChange(row)" />
											<span class="field-error"
												*ngIf="isSubmitted(row) && row.get('vat_percentage').errors?.required">Required</span>
											<span class="field-error"
												*ngIf="isSubmitted(row) && (row.get('vat_percentage').errors?.min || row.get('vat_percentage').errors?.max )">Enter
												valid data (0-100)</span>
										</fieldset>
									</span>
								</td>

								<td class="td-vat-rat" i18n-data-th="@@expenses.net_vat_amount"
									data-th="Net VAT amount">
									<span class="bt-content">
										<span class="sar" [innerHtml]="userInfo?.currency_symbol"></span>
										{{ row.get('net_vat_amount_percent').value }}
									</span>
								</td>

								<td class="td-edit-icon">
									<span class="bt-content">
										<a class="edit" href="javascript:void(0);" (click)="onSubmitEditInputTax(row)">
											<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="12"
												height="12" viewBox="0 0 24 24">
												<path
													d="M 22.59375 3.5 L 8.0625 18.1875 L 1.40625 11.5625 L 0 13 L 8.0625 21 L 24 4.9375 Z">
												</path>
											</svg>
										</a>

										<a class="cross" href="javascript:void(0);" (click)="cancelEditFrom(row);">
											<svg version="1.1" x="0px" y="0px" viewBox="0 0 14 14" width="14"
												height="14" style="enable-background:new 0 0 14 14;"
												xml:space="preserve">
												<path class="svg-stroke" fill="none" stroke-width="2"
													stroke-linecap="square" d="M2.8,11.2l8.5-8.5 M2.8,2.8l8.5,8.5" />
											</svg>
										</a>
									</span>
								</td>

							</tr>
							<!-- End This </tr> is used for edit the record -->

							<ng-template #expenseReadOnly>
								<tr>

									<td class="td-txt-use" scope="row" i18n-data-th="@@expenses.tax_used_for"
										data-th="Tax used for">
										{{ row.get('expense_type').value == 'handling_fees' ? 'COGS' : 'G&A' }}
										<a *ngIf="row.value.attachment" href="{{ row.value.attachment }}"
											target="_blank"><img src="images/attach-icon.png" loading="lazy" /></a>
									</td>

									<td class="td-number" scope="row" i18n-data-th="@@expenses.receipt_invoice_no"
										data-th="Receipt/Invoice no">
										{{ row.get('receipt_number').value }}
									</td>

									<td class="td-date" i18n-data-th="@@expenses.date" data-th="Date">
										<div class="date">
											<span class="day">{{ row.get('expense_date').value | date:'dd' }}</span>
											<span class="month">{{ row.get('expense_date').value | date:'MMM' }}</span>
											<span class="year">{{ row.get('expense_date').value | date:'yyyy' }}</span>
										</div>
									</td>

									<td class="td-client-name" i18n-data-th="@@expenses.vendor" data-th="Vendor">
										<ng-container *ngIf="row.get('vendor_name').value; else elseTemplate">
											{{ row.get('vendor_name').value }}
										</ng-container>
										<ng-template #elseTemplate>
											Unknown
										</ng-template>
									</td>

									<td class="td-vat-reg" i18n-data-th="@@expenses.vat_reg_no" data-th="VAT Reg.No.">
										{{ row.get('vat_number').value }}
									</td>

									<td class="td-project-name" i18n-data-th="@@expenses.description"
										data-th="Description">
										{{ row.get('description').value }}
									</td>

									<td class="td-amount" i18n-data-th="@@expenses.taxable_invoice"
										data-th="Taxable invoice">
										<div class="amount">
											<span class="sar"
												[innerHtml]="row.get('currency').value ? row.get('currency').value : userInfo?.currency_symbol"></span>
											<span class="price">{{ row.get('cost').value | number:'.2' }}</span>
										</div>
									</td>

									<td class="td-net-vat" i18n-data-th="@@expenses.vat_rate" data-th="VAT Rate">
										{{ (row.get('vat_percentage').value ? row.get('vat_percentage').value : 0.00 ) |
										number:'.2' }}%
									</td>

									<td class="td-amount" i18n-data-th="@@expenses.net_vat_amount"
										data-th="Net VAT amount">
										<div class="amount">
											<span class="sar"
												[innerHtml]="row.get('currency').value ? row.get('currency').value : userInfo?.currency_symbol"></span>
											<span class="price">{{ row.get('net_vat_amount_percent').value | number:'.2'
												}}</span>
										</div>
									</td>

									<td class="td-edit-icon">
										<a class="edit" href="javascript:void(0);"
											(click)="row.get('edit').setValue(true)">
											<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19"
												viewBox="0 0 19 19">
												<g fill="none" fill-rule="evenodd">
													<g fill="#1C6AB6">
														<path
															d="M12.683 8.444l-2.134-2.137 1.542-1.545 2.133 2.136-1.541 1.546zM7.189 13.95l-2.357.214.209-2.343 4.447-4.453 2.134 2.137-4.433 4.445zm8.174-8.156h-.001l-2.168-2.171c-.587-.586-1.595-.614-2.15-.055L3.92 10.701c-.258.258-.418.6-.451.962l-.3 3.306c-.02.234.062.466.229.632.15.15.351.232.56.232.024 0 .048 0 .071-.003l3.302-.3c.363-.034.704-.193.961-.45l7.123-7.133c.577-.579.552-1.544-.053-2.152z"
															transform="translate(-875 -616) translate(96 587) translate(779 29)" />
													</g>
												</g>
											</svg>
										</a>
									</td>

								</tr>
							</ng-template>

						</ng-container>
					</ng-container>

					<ng-template #noRecord>
						<tr>
							<td colspan="10" class="text-center">
								<span class="bt-content">
									<ng-container *ngIf="loading; else noRecord"
										i18n="@@common.loading">Loading...</ng-container>
									<ng-template #noRecord>
										<ng-container i18n="@@common.no_record_found">No record found.</ng-container>
									</ng-template>
								</span>
							</td>
						</tr>
					</ng-template>

				</tbody>
			</table>
		</div><!-- end table-responsive -->
	</div><!-- end outer-table-wrap -->
	<ng-container *ngIf="paginator.totalItems > 0">
		<div class="pagination_wrapper">
			<div class="showing_results">
				<!-- <div class="select_wrapper">
					Show
					<select class="select-link tab-links-select" id="tab-links-select">
						<option value="10" >10</option>
						<option value="20" >20</option>
						<option value="50" >50</option>
						<option value="100" >100</option>
					</select>
					items
				</div> -->
				<div class="select_wrapper">
					<ng-container i18n="@@show">Show</ng-container>
					<select class="select-link tab-links-select" id="tab-links-select" nice-select
						[(ngModel)]="itemsPerPage" (change)="onChangeItemsPerPage($event, p)">
						<option *ngFor="let option of itemsPerPageOptions" [value]="option">{{ option }}</option>
					</select>
					<ng-container i18n="@@items">items</ng-container>
				</div>
				<div class="results_list" *ngIf="paginator?.from || paginator?.to">
					Showing from {{ paginator?.from }} to {{ paginator?.to }} of {{ paginator?.totalItems }} items
				</div>
			</div>
			<nav pagination-template #p="paginationApi" [id]="paginator.id" (pageChange)="getPage($event)"
				aria-label="...">
				<ul class="pagination justify-content-center">
					<li class="page-item" [class.disabled]="p.isFirstPage()">
						<a *ngIf="!p.isFirstPage()" class="page-link prev" tabindex="-1" (click)="p.previous()">
							<svg width="7.5" height="13.5">
								<path d="M6.75 12.75l-6-6 6-6" fill="none" class="color-stroke" stroke-linecap="round"
									stroke-linejoin="round" stroke-width="1.5" />
							</svg>
						</a>
					</li>

					<li *ngFor="let page of p.pages" class="page-item" [class.active]="p.getCurrent() === page.value">
						<a *ngIf="p.getCurrent() !== page.value" (click)="p.setCurrent(page.value)" class="page-link">
							<span>{{ page.label }}</span>
						</a>
						<a *ngIf="p.getCurrent() === page.value" class="page-link">{{page.label}}
							<span class="sr-only">(current)</span></a>
					</li>

					<li class="page-item" [class.disabled]="p.isLastPage()">
						<a *ngIf="!p.isLastPage()" (click)="p.next()" class="page-link next">
							<svg width="7.5" height="13.5">
								<path d="M.75.75l6 6-6 6" fill="none" class="color-stroke" stroke-linecap="round"
									stroke-linejoin="round" stroke-width="1.5" />
							</svg>
						</a>
					</li>
				</ul>
			</nav>
		</div>
	</ng-container>
</div>